// dev-requests-04 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "%{campo} (aba %{aba})": "%{campo} (pestaña %{aba})",
    "%{campo}, item %{n}": "%{campo}, ítem %{n}",
    "CNPJ inválido": "CNPJ inválido",
    "Campo não aceito pelo sistema (avise o suporte)": "Campo no aceptado por el sistema (avise a soporte)",
    "Casas decimais demais": "Demasiados decimales",
    "Item inválido na lista": "Ítem inválido en la lista",
    "Número grande demais": "Número demasiado grande",
    "Preencha ao menos um dos campos": "Complete al menos uno de los campos",
    "Quantidade de itens inválida": "Cantidad de ítems inválida",
    "Revise antes de salvar:": "Revise antes de guardar:",
    "Revise os campos em vermelho nas abas: %{abas}": "Revise los campos en rojo en las pestañas: %{abas}",
    "Use só letras e números": "Use solo letras y números",
    "Use um valor entre -%{limite} e %{limite}, com ponto decimal (ex.: -19.9245)": "Use un valor entre -%{limite} y %{limite}, con punto decimal (ej.: -19.9245)",
    "e mais %{n} campo(s)": "y %{n} campo(s) más",
};

export default catalogo;
